import { MessagesView } from "../components/MessagesView";

export function CoachMessagesPage() {
  return <MessagesView mode="coach" />;
}
